import { formatDate } from './requestData';
import { humanVerifyItems } from './reviewRecord';
import { planSideText } from './checkEvidence';

/**
 * What the reviewer does by hand on the Human Verification tab, and how.
 *
 * Which checks are the reviewer's to do is humanVerifyItems in reviewRecord.
 *
 * The how-to lines are the agent's own (each check's coverage.verify_howto). A
 * record from before the agent saved them gets the contractor SOP's dashboard
 * steps below, keyed by the agent's check id.
 */

// The items themselves: the same rule the Validations Performed counts use.
export const verifyItems = humanVerifyItems;

/** The partner's IDs the dashboard searches on, as the request carries them. */
export function dashboardIds(record) {
  const fundRequest = (record && record.validation_data && record.validation_data.complete_api_data
    && record.validation_data.complete_api_data.fundRequest) || {};
  const value = (v) => (typeof v === 'string' || typeof v === 'number') && String(v).trim() !== '' ? String(v).trim() : '';
  return {
    spmsId: value((fundRequest.partner || {}).spmsId),
    fundRequestId: value(fundRequest.fundRequestId) || value(record && record.apfp_fundrequestid),
  };
}

const date = (iso) => {
  const shown = formatDate(iso);
  return typeof shown === 'string' ? shown : iso;
};

const planDatesHow = (evidence) => {
  const c = evidence && evidence.date_comparison;
  if (!c) return 'Check that the plan\'s start and end dates match the request\'s.';
  return `Check the plan's dates against the request's, ${date(c.request_start)} to ${date(c.request_end)}. `
    + `The plan's start reads ${planSideText(c.plan_start)}; its end reads ${planSideText(c.plan_end)}.`;
};

const HOW = {
  // Good Standing.
  '1.1': ({ lookup }) => `On the Partner Funding Dashboard, open Business Approval Validation Search and search ${lookup}. `
    + 'In the Partner Path table, a path should be at Validated or Differentiated. In the APN Fee Billing History table, '
    + 'the status should be Paid, Billing Exempt or Billed, the record type Renewal or New Billing, and the payment '
    + 'within a year plus 90 days of being received.',
  // Annual Cap.
  '1.2': ({ spms }) => `On the Partner Funding Dashboard, open Credit Summary for Sandbox and add up this year's credits for ${spms}, `
    + 'plus this request, against the annual cap. A partner whose SCA covers Sandbox has no cap.',
  // Prior Submission History.
  '1.8': ({ spms }) => `On the Partner Funding Dashboard, open Global Fund Requests and search ${spms}: look at this partner's `
    + 'earlier Sandbox requests and how each ended.',
  // Duplicate Request Detection.
  '1.10': () => 'In the same Global Fund Requests results, look for an earlier request with the same amount or code split that '
    + 'already passed business approval, a very similar business description, or the same pricing calculator.',
  // Plan Dates.
  '3.8': ({ check }) => planDatesHow(check.evidence),
};

/**
 * How the reviewer verifies one item by hand, one line per step: the agent's
 * lines when it saved them (none when it gives no steps), otherwise the SOP's.
 */
export function howToVerify(check, ids) {
  const recorded = check.coverage && check.coverage.verify_howto;
  if (Array.isArray(recorded)) return recorded.filter((line) => typeof line === 'string' && line.trim() !== '');
  const how = HOW[check.id];
  if (!how) return [];
  const spms = ids.spmsId ? `SPMS ID ${ids.spmsId}` : 'the partner\'s SPMS ID';
  const lookup = ids.spmsId ? `SPMS ID ${ids.spmsId}` : `FR ID ${ids.fundRequestId || 'of this request'}`;
  return [how({ check, spms, lookup })];
}
